import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { TeracomBaseUrl } from '../../../utilities/constants';
import DeviceContentContainer from '../../components/device/teracom-device-content-container';
import DeviceMenu from '../../components/device/teracom-device-menu/device-menu';
import DeviceMenuApp from '../../components/device/teracom-device-menu/device-menu-app';
import JmTitle from '../../components/jm-title/jm-title';
import './devices.scss';

const mapStateToProps = (state) => {
  return {
    dateFrom: state.devicesReducer.dateFrom,
    dateTo: state.devicesReducer.dateTo,
  };
};

const TeracomDevices = ({dateFrom, dateTo}) => {
  const [devices, setDevices] = useState(null);
  const [devicesData, setDevicesData] = useState({});
  const loadDevices = async () => {
    const devices = await fetch(`${TeracomBaseUrl}/devices`).then((ret) => ret.json());
    setDevices(devices);
  };

  const loadData = async () => {
    const from = Math.round(new Date(dateFrom).getTime() / 1000);
    const to = Math.round(new Date(dateTo).getTime() / 1000);
    const data = await fetch(`${TeracomBaseUrl}/data/${from}/${to}`).then((ret) => ret.json());
    const newDevicesData = {};
    data.forEach((item) => {
      if (!newDevicesData[item.deviceId]) newDevicesData[item.deviceId] = [];
      item.measurementTime = item.measurementDate * 1000 + item.measurementTime;
      newDevicesData[item.deviceId].push(item);
    });

    setDevicesData(newDevicesData);
  };

  useEffect(() => {
    loadDevices();
  }, []);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateFrom, dateTo]);

  return (
    <JmTitle title="Devices" shouldPrefixBrandName={true}>
      <div>
        <Grid container={true} className="desktop">
          <div className="devicesContainer">
            <DeviceMenu devices={devices} setDevices={setDevices} />
          </div>
          <div className="deviceContentContainer">
            <DeviceContentContainer devices={devices} devicesData={devicesData} />
          </div>
        </Grid>
        <div className="mobile">
          <DeviceMenuApp devices={devices} devicesData={devicesData} setDevices={setDevices} />
        </div>
      </div>
    </JmTitle>
  );
};

export default connect(mapStateToProps)(TeracomDevices);
